<template>
    <div class="form form--new-user">
        <div
            v-if="starsMainCategoriesOptions && starsMainCategoriesOptions.length > 0"
            class="grid">
            <div class="grid__item desktop--10">
                <div class="field">
                    <label class="field__label">{{ $t("category") }}</label>
                    <field-select
                        name="category-star"
                        id="field-add-star-category"
                        input-label-id="field-add-star-category-label"
                        @update-value="updateStarsCurrentCategory"
                        :options="starsMainCategoriesOptions" />
                </div>
            </div>
        </div>
        <div
            v-if="currentStarsOptions && currentStarsOptions.length > 0"
            class="grid">
            <div class="grid__item desktop--10">
                <div class="field">
                    <label class="field__label">{{ $t("celebrity") }}</label>
                    <field-select
                        name="category-star"
                        id="field-add-star"
                        input-label-id="field-add-star-label"
                        @update-value="updateCurrentStar"
                        :options="currentStarsOptions" />
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="grid__item desktop--10">
                <button
                    @click="addStar"
                    class="button button--primary button--fullwidth">{{ $t("add") }}</button>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

import FieldSelect from "@/components/forms/FieldSelect.vue";

import { pad, purify, capitalize } from "@/utils/helpers/string.js";
import { getObjetIndexByKey } from "@/utils/helpers/array.js";

export default {
    name: "NewStarForm",
    components: {
        FieldSelect: FieldSelect,
    },
    data() {
        return {
            currentStarsMainCategory: null,
            currentStar: null,
            stars: []
        };
    },
    computed: {
        starsMainCategoriesOptions() {
            if (this.stars) {
                let categories = [];

                this.stars.map((item) => {
                    const category = item.categ.trim();

                    if (getObjetIndexByKey(categories, "value", category) === -1) {
                        const option = {
                            "value": category,
                            "label": this.$t(category)
                        };

                        categories.push(option);
                    }
                });

                return categories;
            }
        },
        currentStarsOptions() {
            if (this.stars) {
                let stars = [];

                this.stars.map((item) => {
                    if (item.categ.trim() === this.currentStarsMainCategory) {
                        if (getObjetIndexByKey(stars, "id_person", item.id_person) === -1) {
                            stars.push(item);
                        }
                    }
                });

                if (stars.length > 0) {
                    let options = [];

                    stars.map((item) => {
                        const option = {
                            "value": item.id_person,
                            "label": capitalize(item.name)
                        };

                        options.push(option);
                    });

                    return options;
                }
            }
        }
    },
    mounted: function() {
        this.fetchStars();
    },
    methods: {
        updateStarsCurrentCategory(value) {
            this.currentStarsMainCategory = value;
        },
        updateCurrentStar(value) {
            const star = this.stars.find(item => item.id_person === value);

            this.currentStar = star;
        },
        addStar() {
            this.$emit("add-star", this.currentStar);
        },
        // Fetch User Groups Info
        fetchStars() {
            axios({
                url: "/json/stars/star_vocation.json",
            }).then(res => {
                this.stars = res.data;
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
    }
};
</script>

